import { render } from "./EventOccasionsList.vue?vue&type=template&id=f344a670"
import script from "./EventOccasionsList.vue?vue&type=script&lang=js"
export * from "./EventOccasionsList.vue?vue&type=script&lang=js"

import "./EventOccasionsList.vue?vue&type=style&index=0&id=f344a670&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__